export default "__VITE_ASSET__CfCorrWE__"